(function () {
  const VALID_GUIDES = [
    'hub',
    'blinds-measure',
    'blinds-install',
    'curtains-measure',
    'curtains-install'
  ];
  const VALID_FILTERS = ['all', 'measure', 'install', 'blinds', 'curtains'];

  const CTA = {
    blind: {
      label: 'Ready? Design your blind',
      primaryText: 'Design your blind →',
      primaryHref: '/products/blinds',
      secondaryText: 'Design your curtain →',
      secondaryHref: '/products/curtains'
    },
    curtain: {
      label: 'Ready? Design your curtain',
      primaryText: 'Design your curtain →',
      primaryHref: '/products/curtains',
      secondaryText: 'Design your blind →',
      secondaryHref: '/products/blinds'
    }
  };

  let root = null;
  let stepObserver = null;
  let currentGuide = 'hub';
  let hubFilter = 'all';

  function parseGuide() {
    const value = new URLSearchParams(window.location.search).get('guide');
    if (!value || value === 'hub') return 'hub';
    return VALID_GUIDES.indexOf(value) !== -1 ? value : 'hub';
  }

  function parseFilter() {
    const value = new URLSearchParams(window.location.search).get('filter');
    return VALID_FILTERS.indexOf(value) !== -1 ? value : 'all';
  }

  function guideUrl(guide, filter) {
    const url = new URL(window.location.href);
    if (!guide || guide === 'hub') url.searchParams.delete('guide');
    else url.searchParams.set('guide', guide);

    const nextFilter = (!guide || guide === 'hub') ? (filter || hubFilter) : null;
    if (nextFilter && nextFilter !== 'all') url.searchParams.set('filter', nextFilter);
    else url.searchParams.delete('filter');

    url.hash = '';
    return url.pathname + url.search;
  }

  function syncStickyOffset() {
    if (!root) return;
    const fromVar = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height'));
    const header = document.querySelector('sticky-header .header, .section-header .header, .header');
    const height = fromVar || (header ? header.getBoundingClientRect().height : 0);
    if (height > 0) root.style.setProperty('--mg-sticky-top', Math.ceil(height + 16) + 'px');
  }

  function productFor(guide) {
    if (guide === 'curtains-measure' || guide === 'curtains-install') return 'curtain';
    if (guide === 'blinds-measure' || guide === 'blinds-install') return 'blind';
    return null;
  }

  function syncGuideYoutubeIframes() {
    document.querySelectorAll('iframe.guide-youtube-iframe').forEach(function (iframe) {
      const url = iframe.getAttribute('data-src');
      if (!url) return;

      const view = iframe.closest('[data-guide-view]');
      const panel = iframe.closest('[data-fit-panel]');
      const viewOn = view && !view.hidden;
      const panelOn = !panel || !panel.hidden;

      if (viewOn && panelOn) {
        if (iframe.getAttribute('src') !== url) iframe.setAttribute('src', url);
      } else if (iframe.hasAttribute('src')) {
        iframe.removeAttribute('src');
      }
    });
  }

  function updateGuideCta(guide) {
    const product = productFor(guide);
    if (!product) return;
    const copy = CTA[product];
    const view = root.querySelector('[data-guide-view="' + guide + '"]');
    if (!view || !copy) return;

    const label = view.querySelector('[data-guide-cta-label]');
    const primary = view.querySelector('[data-guide-cta-primary]');
    const secondary = view.querySelector('[data-guide-cta-secondary]');
    if (label) label.textContent = copy.label;
    if (primary) {
      primary.href = copy.primaryHref;
      primary.textContent = copy.primaryText;
    }
    if (secondary) {
      secondary.href = copy.secondaryHref;
      secondary.textContent = copy.secondaryText;
    }
  }

  function applyHubFilter(name, pushUrl) {
    hubFilter = name || 'all';
    root.querySelectorAll('.ib-guides__filter').forEach(function (btn) {
      const on = btn.getAttribute('data-filter') === hubFilter;
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    root.querySelectorAll('.ib-guides__card').forEach(function (card) {
      const topics = (card.getAttribute('data-topics') || '').split(/\s+/);
      card.hidden = hubFilter !== 'all' && topics.indexOf(hubFilter) === -1;
    });
    if (pushUrl && currentGuide === 'hub') {
      history.replaceState({ guide: 'hub', filter: hubFilter }, '', guideUrl('hub', hubFilter));
    }
  }

  function setFit(group, fit) {
    if (!group || !fit) return;
    group.querySelectorAll('[data-fit]').forEach(function (btn) {
      const on = btn.getAttribute('data-fit') === fit;
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    group.querySelectorAll('[data-fit-panel]').forEach(function (panel) {
      panel.hidden = panel.getAttribute('data-fit-panel') !== fit;
    });
    syncGuideYoutubeIframes();
  }

  function setNavCurrent(link) {
    const nav = link && link.closest('.ib-guide__nav');
    if (!nav) return;
    nav.querySelectorAll('.ib-guide__nav-link').forEach(function (item) {
      if (item === link) item.setAttribute('aria-current', 'true');
      else item.removeAttribute('aria-current');
    });
  }

  function observeSteps(article) {
    if (stepObserver) {
      stepObserver.disconnect();
      stepObserver = null;
    }
    if (!article) return;

    const links = article.querySelectorAll('.ib-guide__nav-link');
    const steps = article.querySelectorAll('.ib-guide__step');
    if (!links.length || !steps.length) return;

    stepObserver = new IntersectionObserver(function (entries) {
      const visible = entries
        .filter(function (entry) { return entry.isIntersecting; })
        .sort(function (a, b) { return b.intersectionRatio - a.intersectionRatio; })[0];
      if (!visible) return;
      const id = visible.target.id;
      const link = article.querySelector('.ib-guide__nav-link[href="#' + id + '"]');
      if (link) setNavCurrent(link);
    }, {
      root: null,
      rootMargin: '-20% 0px -55% 0px',
      threshold: [0.1, 0.25, 0.5]
    });

    steps.forEach(function (step) { stepObserver.observe(step); });
    if (links[0]) setNavCurrent(links[0]);
  }

  function showView(guide, opts) {
    const next = VALID_GUIDES.indexOf(guide) !== -1 ? guide : 'hub';
    currentGuide = next;
    const shouldScroll = !opts || opts.scroll !== false;

    root.querySelectorAll('[data-guide-view]').forEach(function (el) {
      const on = el.getAttribute('data-guide-view') === next;
      el.hidden = !on;
    });

    if (next === 'hub') applyHubFilter(hubFilter);

    const article = next === 'hub' ? null : root.querySelector('[data-guide-view="' + next + '"]');
    observeSteps(article);
    syncGuideYoutubeIframes();
    updateGuideCta(next);

    if (shouldScroll && root) {
      const top = root.getBoundingClientRect().top + window.scrollY - 16;
      window.scrollTo({ top: Math.max(0, top), behavior: opts && opts.instant ? 'auto' : 'smooth' });
    }

    if (article) {
      const firstFit = article.querySelector('[data-fit].is-active, [data-fit]');
      if (firstFit) {
        const group = firstFit.closest('[data-fit-group]') || article;
        const current = group.querySelector('[data-fit].is-active') || firstFit;
        setFit(group, current.getAttribute('data-fit'));
      }
    }
  }

  function navigate(guide, push) {
    const next = VALID_GUIDES.indexOf(guide) !== -1 ? guide : 'hub';
    if (push) history.pushState({ guide: next }, '', guideUrl(next));
    showView(next);
  }

  function toggleAccordion(btn) {
    if (!btn) return;
    const content = btn.nextElementSibling;
    const open = !btn.classList.contains('open');
    btn.classList.toggle('open', open);
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (content) {
      content.classList.toggle('open', open);
      content.hidden = !open;
    }
  }

  function onClick(event) {
    const filterBtn = event.target.closest('.ib-guides__filter[data-filter]');
    if (filterBtn && root.contains(filterBtn)) {
      applyHubFilter(filterBtn.getAttribute('data-filter'), true);
      return;
    }

    const fitBtn = event.target.closest('[data-fit]');
    if (fitBtn && root.contains(fitBtn)) {
      const group = fitBtn.closest('[data-fit-group]') || fitBtn.closest('[data-guide-view]');
      setFit(group, fitBtn.getAttribute('data-fit'));
      return;
    }

    const accBtn = event.target.closest('[data-accordion-toggle]');
    if (accBtn && root.contains(accBtn)) {
      toggleAccordion(accBtn);
      return;
    }

    const stepLink = event.target.closest('.ib-guide__nav-link');
    if (stepLink && root.contains(stepLink) && stepLink.hash) {
      const target = document.getElementById(stepLink.hash.slice(1));
      if (target) {
        event.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        setNavCurrent(stepLink);
      }
      return;
    }

    const navLink = event.target.closest('a[data-guide-nav]');
    if (!navLink || !root.contains(navLink)) return;

    const url = new URL(navLink.href, window.location.origin);
    const here = window.location.pathname.replace(/\/$/, '');
    const there = url.pathname.replace(/\/$/, '');
    if (here && there && here !== there) return;

    event.preventDefault();
    const requested = url.searchParams.get('guide');
    const filter = url.searchParams.get('filter');
    if (!requested || requested === 'hub') {
      hubFilter = VALID_FILTERS.indexOf(filter) !== -1 ? filter : 'all';
    }
    navigate(requested && VALID_GUIDES.indexOf(requested) !== -1 ? requested : 'hub', true);
  }

  function init() {
    root = document.querySelector('[data-ib-guides]');
    if (!root) return;

    currentGuide = parseGuide();
    hubFilter = parseFilter();
    syncStickyOffset();
    window.addEventListener('resize', syncStickyOffset);
    showView(currentGuide, { scroll: false, instant: true });

    root.addEventListener('click', onClick);
    window.addEventListener('popstate', function () {
      showView(parseGuide(), { scroll: false });
    });
  }

  window.toggleAccordion = toggleAccordion;
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
